/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { Linkable } from '@/components/blocks/Linkable';
import { useHelloRetailSearch } from '@/data/Content/HelloRetailSearch';
import { useLocalization } from '@/data/Localization';
import { ContentContext } from '@/data/context/content';
import { Box, Stack, SxProps, Typography } from '@mui/material';
import { FC, useContext } from 'react';
import { categoryButtonsSX, categoryTextSX, catNavContainerSX } from '../../styles/HelloRetailSearch/HelloRetailProductList';

export const HelloRetailCategoryList: FC<{styles?:Record<string, SxProps>}> = ({styles}) => {
	const {
		categoryFacet
	} = useContext(ContentContext) as ReturnType<typeof useHelloRetailSearch>;

	const categoryNLS = useLocalization("Category");

	return (
		categoryFacet && categoryFacet?.length > 0 ?
			<Stack sx={styles?.container??{}}>
				<Typography sx={categoryTextSX}>{categoryNLS.OverlayCategoryText.t()}</Typography>
				<Stack
					sx={catNavContainerSX}
					id="category_navigation_widget"
				>
					{categoryFacet.map((c, i) => <Linkable href={c.originalUrl} sx={categoryButtonsSX} key={i}>
						{c.title}
					</Linkable>
					)}
				</Stack>
			</Stack>
			: null
	);
};
